import { Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
const { Link } = Typography;

const Timer = ({ time = null, action }) => {
  const [remainingTime, setRemainingTime] = useState(0);
  const [isActive, setIsActive] = useState(true);

  const formatTime = useCallback((seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  }, []);

  useEffect(() => {
    if (remainingTime <= 0) {
      setIsActive(false);
      return;
    }

    const timer = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingTime]);

  useEffect(() => {
    if (time) {
      setRemainingTime((time - 1) * 60);
      setIsActive(true);
    }
  }, [time]);

  const handleChangeRating = useCallback(() => {
    if (isActive) {
      action();
    }
  }, [isActive, action]);

  if (!isActive) return null;

  return (
    <div className="flex justify-center mt-4">
      {isActive ? (
        <Link
          className="hover:underline underline-offset-[3px] text-xs"
          onClick={handleChangeRating}
        >
          {formatTime(remainingTime)} - Ubah Rating
        </Link>
      ) : (
        <p className="text-xs">Waktu untuk mengubah rating telah habis</p>
      )}
    </div>
  );
};

export default Timer;
